export const IntegrationsItem = {
  extends: 'DomainItem',
  align: 'start',
  state: {
    icon: 'plus',
    title: 'apps.integration.custom.title',
    descr: 'apps.integration.custom.descr'
  },
  Icon: {
    name: '{{ icon }}'
  },
  Hgroup: {
    H: {
      text: (el, s) => el.call('polyglot', s.title || '')
    },
    P: {
      text: (el, s) => el.call('polyglot', s.descr || '')
    }
  },
  Button: {
    extends: ['CanvasButton', 'Button'],
    margin: '-Y -Z2 - auto',
    icon: 'plus oval',
    text: '{{ publish.sync.connect | polyglot }}',
    gap: 'Y1',
    padding: 'Y2 Z2',
    fontSize: 'Z2',
    Icon: {
      order: 2,
      color: 'blue'
    },
    onClick: (ev, el, s) => s.onAdd?.(el, s)
  },
  Upgrade: null
}
